<template>
  <div>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
          <h1>Willkommen auf suche-regional.at</h1>
          <h2>Einkaufen / Shopping in Zeiten der Coronakrise</h2>
          <p>Welche Geschäfte haben in Deinem Bezirk geöffnet, bieten Lieferservice, sonstige Dienste oder Online-Shopping Möglichkeiten?</p>
          <h3>Gemeinsam durch die Krise!</h3>
          <p>Ob Apotheke, Lebensmittelgeschäft oder Zahnarzt - ohne unseren regionalen Betriebe und Dienstleister wären wir aktuell hilflos!<br>
            Deswegen, unterstützt gemeinsam mit uns die regionalen Wirtschaftsbetriebe!</p>
          <p>Vom Großunternehmen bis hin zu den vielen Klein- und Mittelbetrieben, Selbstständigen und Ein-Personen-Unternehmen.<br>
            Alle sind in dieser schwierigen Zeit gefordert und haben finanzielle Einbußen hinzunehmen.<br>
            Lassen wir die Wertschöpfung in den Regionen! Auch nach der Krise!</p>
          <p>Trag Dich selber ein, wenn du Unternehmer bist oder eine Dienstleistung anzubieten hast.<br>
            Bitte sage es weiter, wenn Du jemanden in Deinem Bekannten- und Freundeskreis kennst, der sich hier eintragen kann.<br>
            Umso umfangreicher die Liste, umso hilfreicher für uns alle!</p>
          <p><strong>Die Eintragung ist kostenlos!</strong><br>
            Wir stellen die Information auf suche-regional.at in diesen Krisenzeiten unentgeltlich zur Verfügung und hoffen,<br>
            daß diese Auflistung vielen Betrieben und Mitmenschen hilft.</p>
          <router-link to="/about">Wie kann ich mich eintragen?</router-link>
        </v-col>
      </v-row>
    </v-container>
    <Categories></Categories>
    <Filtering></Filtering>
  </div>
</template>

<script>
import Categories from "../components/Categories";
import Filtering from "../components/Filtering";

export default {
  name: 'Home',
  components: {
    Filtering,
    Categories
  }
}
</script>
